import {
  Box,
  Button,
  ButtonBase,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  makeStyles,
  Popover,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import React from 'react';
import { LocationOn, MyLocation } from '@material-ui/icons';
import { SearchBlock } from './SearchBlock';
import { getCoords } from 'services/Geolocation';
import { apiGet } from 'services/api';
import { get } from 'lodash';
import DynamicIcon from './DynamicIcon';
import { searchPreProcessor } from '../../util/LocationUtils';
import { sendAmplitudeData } from 'util/amplitude';
import NewMapComponent from './NewMapContainer';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

export const GoogleLocationSelector = ({
  open,
  onClose,
  currentLocation,
  setCurrentLocation,
  value,
  loading,
  locationFunction,
  pickCurrentLocation,
  processingLocation,
  setProcessingLocation,
  ...props
}) => {
  let google = React.useRef({ current: {} });
  let searchField = React.useRef({ current: {} });
  const [currentMarker, setCurrentMarker] = React.useState(undefined);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isSmallScreen = useMediaQuery('(max-height:768px)');
  React.useEffect(() => {
    currentLocation &&
      setCurrentMarker(`${currentLocation.lat},${currentLocation.lng}`);
  }, [currentLocation]);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleFieldClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const queryFunction = (
    searchString,
    optionsList,
    setList,
    preProcessorResult
  ) => {
    apiGet(
      `/get-locations?search=${searchString}`,
      preProcessorResult.options
    ).then((response) => {
      setList(get(response, ['data'], {}).results);
    });
  };
  const dragMarker = (mapProps, map, event) => {
    !processingLocation &&
      setCurrentMarker(`${mapProps.latLng.lat()},${mapProps.latLng.lng()}`);
  };
  const mapDragEnd = (center) => {
    setCurrentMarker(`${center.lat},${center.lng}`);
  };

  const popoverOpen = Boolean(anchorEl);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      PaperProps={{
        style: { width: '100%', maxWidth: '95vw', overflow: 'hidden' },
      }}
    >
      <DialogContent
        style={{
          padding: 0,
          overflow: 'auto',
          minHeight: '90vh',
          width: '100%',
          background: '#FDFDFF',
        }}
      >
        <div>
          <div
            style={{
              position: 'absolute',
              zIndex: 1,
              right: 0,
              height: 50,
              width: '100%',
              // padding: 10,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #E2E2E2',
                paddingLeft: 20,
              }}
            >
              <Typography
                style={{ fontSize: 17.5, color: '#505050', opacity: 1 }}
                noWrap={true}
                flex={1}
                spacing={1}
              >
                Select Location
              </Typography>
              <div>
                <Button
                  style={{
                    background: '#233C97',
                    color: '#ffffff',
                    margin: 5,
                    fontWeight: 'bold',
                  }}
                  onClick={() => {
                    if (!processingLocation && !loading && !!currentMarker) {
                      sendAmplitudeData('Location Picked from Map', {
                        lat: getCoords({ ['location']: currentMarker }).lat,
                        lng: getCoords({ ['location']: currentMarker }).lng,
                      });
                      setCurrentLocation(
                        getCoords({ ['location']: currentMarker })
                      );
                      locationFunction(
                        getCoords({ ['location']: currentMarker })
                      );
                      onClose();
                    }
                  }}
                >
                  Done
                </Button>
                <Button
                  style={{
                    background: '#FA4C5D',
                    color: '#ffffff',
                    margin: 5,
                    fontWeight: 'bold',
                  }}
                  onClick={() => {
                    !!currentLocation &&
                      setCurrentMarker(
                        `${currentLocation.lat},${currentLocation.lng}`
                      );
                    onClose();
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
            <div
              style={{
                padding: `${isSmallScreen ? '20' : '32'}px 10px 0px 20px`,
                maxHeight: isSmallScreen ? '27.5vh' : '25vh',
                overflow: 'auto',
                background: '#ffffff',
              }}
            >
              <Box
                spacing={1}
                display="flex"
                justifyContent="center"
                flexDirection="column"
              >
                <ButtonBase style={{ width: '100%', textAlign: 'left' }}>
                  <div
                    ref={searchField}
                    onClick={(event) =>
                      !processingLocation && !loading && handleFieldClick(event)
                    }
                    style={{
                      flex: 1,
                      border: '1px solid #E5E5E5',
                      borderRadius: 5,
                      fontSize: 17.5,
                      padding: 10,
                      cursor: 'pointer',
                      color: '#909090',
                    }}
                  >
                    {'Search for area, street name... '}
                  </div>
                </ButtonBase>
                {!loading && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      marginTop: 4,
                    }}
                  >
                    <DynamicIcon
                      iconId={154}
                      style={{
                        height: 14,
                        width: 14,
                        marginTop: 4,
                        marginRight: 4,
                      }}
                    />
                    <Typography
                      style={{
                        color: '#454545',
                        fontSize: isSmallScreen ? 14 : 16,
                      }}
                    >
                      Drag the marker to select the location.
                    </Typography>
                  </div>
                )}
              </Box>
            </div>
          </div>
        </div>
        <div>
          {loading ? (
            <div
              style={{
                width: '100%',
                height: '70vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress
                size={50}
                disableShrink={true}
                color="primary"
              />
            </div>
          ) : (
            <>
              <IconButton
                variant="contained"
                style={{
                  position: 'absolute',
                  bottom: 24,
                  left: 8,
                  zIndex: 1,
                  background: '#233C97',
                  color: '#ffffff',
                  fontWeight: 'bold',
                }}
                onClick={(e) => {
                  setProcessingLocation(true);
                  e.stopPropagation();
                  pickCurrentLocation();
                }}
              >
                {processingLocation ? (
                  <CircularProgress size={22} style={{ color: '#ffffff' }} />
                ) : (
                  <>
                    {' '}
                    <MyLocation style={{ color: '#ffffff' }} />{' '}
                  </>
                )}
              </IconButton>
              <NewMapComponent
                zoom={17}
                googleRef={(ref) => {
                  google.current.googleRef = ref;
                }}
                style={{ height: '100%' }}
                initialCenter={currentLocation}
                center={currentLocation}
                containerStyle={{
                  position: 'absolute',
                  bottom: 0,
                  width: '100%',
                  height: 'calc(100% - 160px)',
                }}
                markers={[
                  {
                    name: 'Current Location',
                    icon: 'map-pin',
                    google: google.current.googleRef,
                    draggable: true,
                    onDragend: dragMarker,
                  },
                ]}
                centeredMarker={true}
                onDragEnd={mapDragEnd}
              />
            </>
          )}
        </div>
        <Popover
          open={popoverOpen}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              width: props.isMobile
                ? searchField && (searchField.current || {}).offsetWidth
                : '50vw',
              maxHeight: isSmallScreen ? '50vh' : '70vh',
              overflow: 'hidden',
            },
          }}
        >
          <SearchBlock
            onSelect={(selected) => {
              setCurrentLocation(getCoords(selected));
              handleClose();
            }}
            searchType={'location'}
            queryFunction={queryFunction}
            isAsyncSearch={true}
            searchPreProcessor={searchPreProcessor}
            isSmallScreen={isSmallScreen}
          />
        </Popover>
      </DialogContent>
    </Dialog>
  );
};
